import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import React from 'react';
import If from './If';
import Image from './Image';

interface GalleryImageProps {
  url: string;
  src_sm: string;
  src_md: string;
  src_lg: string;
  src_xl: string;
  altText: string;
}

function GalleryImageSmall(props: GalleryImageProps) {
  return (
    <Box>
      <Image
        className='product-gallery-small'
        src={props.src_sm}
        alt={props.altText}
        height={128}
      />
    </Box>
  );
}

function GalleryImageLarge(props: GalleryImageProps) {
  return (
    <Box
      display='flex'
      justifyContent='center'
      p={1}
      sx={{ fit: 'scale-down' }}
    >
      <Image
        className='product-gallery-large'
        src={props.src_lg}
        alt={props.altText}
        height={500}
      />
    </Box>
  );
}
interface ProductGalleryProps {
  images: GalleryImageProps[];
  index: number;
  setIndex: (a: number) => void;
}

export default function ProductGallery(props: ProductGalleryProps) {
  const index = props.images[props.index] ? props.index : 0;

  return (
    <>
      <Stack display='flex' justifyContent='center' width='100%'>
        <GalleryImageLarge {...props.images[index]}></GalleryImageLarge>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          display='flex'
          justifyContent='center'
          alignItems='center'
        >
          {props.images.map((item) => (
            <Box
              onClick={() => {
                props.setIndex(props.images.indexOf(item));
              }}
              key={props.images.indexOf(item)}
              sx={{
                height: { md: '600', lg: '1200' },
                p: 1,
              }}
            >
              <If value={props.images.length > 1}>
                <GalleryImageSmall {...item}></GalleryImageSmall>
              </If>
            </Box>
          ))}
        </Stack>
      </Stack>
    </>
  );
}
